import React from 'react'
import moment from 'moment'
import { clubDays, closingTime } from './clubCreationForm'

const clockPattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/
export const clubDayHours = (hours, day) => hours?.[day] || hours?.[clubDays[day].toLowerCase()] || {}
export const clubClock = (entry, side) => {
  if (side === 'end' && entry?.endTime === '24:00') return '00:00'
  if (clockPattern.test(entry?.[side + 'Time'])) return entry[side + 'Time']
  const value = entry?.[side + 'Date']
  return value && moment(value).isValid() ? moment(value).format('HH:mm') : ''
}
export const invalidChangedHours = (hours, original) => Object.keys(clubDays).some(day => {
  const entry = clubDayHours(hours, day)
  if (JSON.stringify(entry) === JSON.stringify(clubDayHours(original, day)) || entry.enabled !== true) return false
  const start = clubClock(entry, 'start'), end = closingTime(clubClock(entry, 'end'))
  return !start || !end || end <= start
})
export default function ClubHoursEditor({ value, onChange }) {
  const change = (day, entry) => {
    const next = { ...value }
    delete next[clubDays[day].toLowerCase()]
    if (entry) next[day] = entry
    else delete next[day]
    onChange(next)
  }
  return <><p className="text-muted">Local club time. Leave unknown hours as Not provided.</p>
    {Object.entries(clubDays).map(([day, label]) => {
      const entry = clubDayHours(value, day)
      const state = entry.enabled === false ? 'closed' : entry.enabled === true ? 'open' : ''
      const time = side => event => {
        const next = { enabled: true, startTime: clubClock(entry, 'start'), endTime: clubClock(entry, 'end'), [side + 'Time']: event.target.value }
        change(day, { ...next, endTime: closingTime(next.endTime) })
      }
      return <div className="row mb-3" key={day}>
        <div className="col-12 col-sm-4"><label htmlFor={'edit-' + day}>{label} schedule</label>
          <select id={'edit-' + day} className="form-control" value={state} onChange={event => change(day,
            event.target.value === 'closed' ? { enabled: false } : event.target.value === 'open'
              ? { enabled: true, startTime: '', endTime: '' } : null)}>
            <option value="">Not provided</option><option value="open">Open</option><option value="closed">Closed</option>
          </select></div>
        {state === 'open' && ['start', 'end'].map(side => <div key={side} className="col-6 col-sm-4">
          <label htmlFor={'edit-' + day + side}>{label} {side === 'start' ? 'opens' : 'closes'}</label>
          <input id={'edit-' + day + side} className="form-control" type="time" value={clubClock(entry, side)} onChange={time(side)} />
        </div>)}
      </div>
    })}</>
}
